import React, { Component } from 'react';
import PatientInfo from 'shared_components/patient_info_panel';
import { Row, Col, Typography } from 'antd';

import ForScreening from './for_screening_tab';

const { Title, Text } = Typography;

export default class ScreeningInformation extends Component {
	render() {
		const { state: donorDetail } = this.props.location;
		const donorDetailsData = donorDetail.donorDetail;
		const { last_name, first_name, middle_name, donor_id } = donorDetail.donorDetail;

		return (
			<div>
				<Row justify={'center'}>
					<Col md={24} lg={7} xxl={7} style={{ marginBottom: 20 }}>
						<PatientInfo data={donorDetailsData} />
					</Col>
					<Col md={24} lg={16} xxl={16} style={{ marginLeft: 20 }}>
						<div>
							<Title level={4}>
								{' '}
								{`${last_name}, ${first_name} ${middle_name}`.toUpperCase()}{' '}
							</Title>
							<Text> DONOR ID : {`${donor_id}`.toUpperCase()} </Text>
						</div>
						<div style={{ marginTop: 20 }}>
							<ForScreening donorDetail={donorDetail} />
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}
